import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@/app/App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

// Minimal global reset injected once — components style via CSS variables.
const globalCss = `
  *, *::before, *::after { box-sizing: border-box; }
  html, body, #root { margin: 0; height: 100%; }
  body {
    font-family: system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
    background: var(--rt-bg);
    color: var(--rt-text);
    -webkit-font-smoothing: antialiased;
  }
`;
const styleTag = document.createElement('style');
styleTag.textContent = globalCss;
document.head.appendChild(styleTag);

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
